import { IconBorderCornerPill, IconBorderCornerSquare } from '@tabler/icons-react';
import { memo, useCallback, useMemo } from 'react';
import PlayerMenuTooltip from '../PlayerMenus/PlayerMenuTooltip';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { updateSpeakerLabelStyles } from '@/stores/clip';
import {
  getSpeakerLabelBorderRadiusDefault,
  getSpeakerLabelBorderRadiusFull
} from '@/player-config/src/utils/speakerLabelUtils';

function SpeakerLabelBorderRadiusToggle() {
  const { clipId, clipData } = useClipsContext();

  const currentBorderRadius = useMemo(
    () => clipData.asset_metadata.speaker_label_styles?.border_radius || getSpeakerLabelBorderRadiusDefault(),
    [clipData.asset_metadata.speaker_label_styles?.border_radius]
  );

  const isRounded = useMemo(() => {
    return currentBorderRadius === getSpeakerLabelBorderRadiusFull();
  }, [currentBorderRadius]);

  const toggleBorderRadius = useCallback(() => {
    updateSpeakerLabelStyles(clipId, {
      border_radius: isRounded ? getSpeakerLabelBorderRadiusDefault() : getSpeakerLabelBorderRadiusFull()
    });
  }, [clipId, isRounded]);

  return (
    <button
      onClick={toggleBorderRadius}
      data-testid="speaker-label-border-radius-toggle"
      className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
    >
      {isRounded ? <IconBorderCornerPill size={20} /> : <IconBorderCornerSquare size={20} />}
      <PlayerMenuTooltip content="Corner radius" />
    </button>
  );
}

export default memo(SpeakerLabelBorderRadiusToggle);
